import React from "react";

const OrdersLoading = () => {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="border-border bg-background animate-pulse rounded-lg border p-6"
        >
          {/* Header with status badge */}
          <div className="mb-4 flex items-center justify-between">
            <div className="bg-muted h-6 w-20 rounded-full"></div>
            <div className="bg-muted h-5 w-16 rounded"></div>
          </div>

          {/* Order ID */}
          <div className="bg-muted mb-3 h-5 w-24 rounded"></div>

          {/* Customer info */}
          <div className="mb-4 space-y-2">
            <div className="bg-muted h-4 w-32 rounded"></div>
            <div className="bg-muted h-4 w-28 rounded"></div>
          </div>

          {/* Order items */}
          <div className="mb-4 space-y-2">
            <div className="bg-muted h-3 w-full rounded"></div>
            <div className="bg-muted h-3 w-3/4 rounded"></div>
            <div className="bg-muted h-3 w-1/2 rounded"></div>
          </div>

          {/* Total */}
          <div className="bg-muted mb-4 h-5 w-20 rounded"></div>

          {/* Footer buttons */}
          <div className="flex space-x-2">
            <div className="bg-muted h-8 w-20 rounded"></div>
            <div className="bg-muted h-8 w-24 rounded"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersLoading;
